import PageHeader from "@ui/components/layout/PageHeader";
import { HeaderPatternConfig } from "@ui/context/component-config-context";

const headerPatternConfig: HeaderPatternConfig = {
  indent: false,
  topSpacing: false,
  header: false,
  topPadding: false,
  componentContext: {
    categoryPillar: {
      indent: false,
    },
    latestRecirc: {
      header: <PageHeader title="The Latest" headingLevel="h2" size="medium" />,
      topPadding: false,
    },
    recommendedRecirc: {
      header: (
        <PageHeader
          title="Recommended For You"
          headingLevel="h2"
          size="medium"
        />
      ),
    },
  },
};

export default headerPatternConfig;
